import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import history from "./history";
import NotFound from "./components/NotFound";
import DocumentTitleProvider from "./components/DocumentTitleProvider";
import SurveyContainer from "./modules/survey/containers/SurveyContainer";
import DashboardContainer from "./modules/dashboard/containers/DashboardContainer";
import UploadPatientContainer from "./modules/uploadPatients/containers/UploadPatientsContainer";
import SigninContainer from "./modules/signin/containers/SigninContainer";
import PatientDetailContainer from "./modules/patient/container/PatientDetailContainer";
import PatientAddContainer from "./modules/patient/container/PatientAddContainer";
import PatientEditContainer from "./modules/patient/container/PatientEditContainer";
import SiteHeader from "./components/SiteHeader";
import MessagePatientContainer from "./modules/messagePatient/containers/MessagePatientContainer";
import MessageFamilyContainer from "./modules/messageFamily/containers/MessageFamilyContainer";
import VideoChatContainer from "./modules/videoChat/containers/VideoChatContainer";
import ScheduleVideoChatContainer from "./modules/scheduleVideoChat/containers/ScheduleVideoChatContainer";
import AppointmentDemoContainer from "./modules/appointmentsDemo/containers/AppointmentsDemoContainer";
import QuickContactContainer from "./modules/quickContact/containers/QuickContactContainer";
import FlashProvider from "./modules/flash/containers/FlashProvider";
import SessionProvider from "./modules/session/containers/SessionProvider";
import OrganizationProvider from "./modules/organizations/containers/OrganizationProvider";
import MultiOrgSelectContainer from "./modules/organizations/containers/MultiOrgSelectContainer";
import SecureMessageContainer from "./modules/secureMessage/containers/SecureMessageContainer";
import PendoDataProvider from "./components/PendoDataProvider";
import PsMobileTestPageContainer from "./modules/psMobileTestPage/containers/PsMobileTestPageContainer";
import TmiqMobileLandingPageContainer from "./modules/tmiqMobileLandingPage/TmiqMobileLandingPageContainer";
import AppointmentPage from "./modules/appointments/AppointmentPage";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import VerticalHeightProvider from "./components/VerticalHeightProvider";
import MessagingPage from "./modules/messaging/MessagingPage";
import MobileConversationPage from "./modules/messaging/MobileConversationPage";
import FamilyCommunicationsPage from "./modules/familyCommunication/FamilyCommunicationPage";

export default () => (
  <>
    <ConnectedRouter history={history}>
      <div className="app">
        <SiteHeader />
        <VerticalHeightProvider />
        <Switch>
          <Route path="/video_chat/:participantUid/" exact component={VideoChatContainer} />
          <Route path="/message/:messageId" exact component={SecureMessageContainer} />
          <Route path="/psMobileTestPage/" exact component={PsMobileTestPageContainer} />
          <Route path="/dev/appointments/" exact component={AppointmentDemoContainer} />
          <Route path="/tmiqMobilePage/" exact component={TmiqMobileLandingPageContainer} />
          <Route path="/" exact component={SigninContainer} />
          <Route path="*">
            <SessionProvider>
              <OrganizationProvider>
                <Route
                  render={({ location }) => (
                    <TransitionGroup>
                      <CSSTransition key={location.key} timeout={600} classNames="fade">
                        <div className="app-content">
                          <Switch location={location}>
                            <Route path="/appointments/" exact component={AppointmentPage} />
                            <Route path="/covid/:covidId/" exact component={SurveyContainer} />
                            <Route
                              path="/uploadPatients/"
                              exact
                              component={UploadPatientContainer}
                            />
                            <Route path="/dashboard/" exact component={DashboardContainer} />
                            <Route path="/messaging/" exact component={MessagingPage} />
                            <Route
                              path="/messaging/:conversationId?/"
                              exact
                              component={MobileConversationPage}
                            />

                            <Route path="/quickContact/" exact component={QuickContactContainer} />
                            <Route
                              path="/patient/:patientId/message"
                              exact
                              component={MessagePatientContainer}
                            />
                            <Route
                              path="/patient/:patientId/message/family"
                              exact
                              component={MessageFamilyContainer}
                            />
                            <Route
                              path="/scheduleVideoChat/"
                              exact
                              component={ScheduleVideoChatContainer}
                            />
                            <Route path="/patient/add/" exact component={PatientAddContainer} />
                            <Route
                              path="/patient/:patientId/"
                              exact
                              component={PatientDetailContainer}
                            />
                            <Route
                              path="/patient/:patientId/edit/"
                              exact
                              component={PatientEditContainer}
                            />
                            <Route
                              path="/changeOrganization/"
                              exact
                              component={MultiOrgSelectContainer}
                            />
                            <Route
                              path="/patient/:patientId/family/"
                              exact
                              component={FamilyCommunicationsPage}
                            />
                            <Route component={NotFound} />
                          </Switch>
                        </div>
                      </CSSTransition>
                    </TransitionGroup>
                  )}
                />
                <PendoDataProvider />
              </OrganizationProvider>
            </SessionProvider>
          </Route>
        </Switch>

        <FlashProvider />
      </div>
    </ConnectedRouter>
    <DocumentTitleProvider title={"PerfectServe Reach"} />
  </>
);
